module.exports = __webpack_public_path__ + "static/media/error-icon.1b29ab77.png";